module.exports = __webpack_public_path__ + "static/media/bri.b7b96ff4.svg";